import { APIContext, APITypesV1 } from "@cur8/api-client";

// TODO: this is a temporary function to create the timeline API client.
// We need to move this to the API client once we have a proper API client.
export function createTimelineAPI({ buildURL, fetchJSON }: APIContext) {
  return {
    fetchLatestTimelineEvent({
      patientId,
      visitId,
    }: {
      patientId: string;
      visitId: string;
    }) {
      const path = [
        "api",
        "v1",
        "patient",
        patientId,
        "visit",
        visitId,
        "timeline-events",
        "latest",
      ]
        .map(encodeURIComponent)
        .join("/");
      const request = new Request(buildURL(path), {
        headers: { accept: "application/json" },
      });
      return fetchJSON<APITypesV1.TimelineEventDto>(request);
    },
  };
}
